var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 135,
    viewBox: "0 0 134 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 0.953613C104.003 0.953613 134 30.9506 134 67.9536C134 104.957 104.003 134.954 67 134.954C29.997 134.954 0 104.957 0 67.9536C0 30.9506 29.997 0.953613 67 0.953613V0.953613Z",
    fill: "#151447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3247 53.8447L70.6038 61.3409L61.9718 66.1112L49.478 73.6075C47.8879 74.5162 45.8435 74.5162 44.0262 73.6075L34.2583 67.7014C32.6683 66.7927 31.5325 64.9755 31.5325 62.931V51.573C31.5325 49.7558 32.4411 47.9385 34.2583 46.8027L44.0262 41.1238C45.6163 40.2151 47.6607 40.2151 49.478 41.1238L59.2459 47.0299C60.8359 47.9385 61.9718 49.7558 61.9718 51.8002V59.2965L70.6038 54.299V46.5756C70.6038 44.7583 69.6952 42.941 67.8779 41.8052L49.7052 31.1287C48.115 30.2201 46.0707 30.2201 44.2534 31.1287L25.6263 42.0324C23.809 42.941 22.9004 44.7583 22.9004 46.5756V67.9285C22.9004 69.7458 23.809 71.5631 25.6263 72.6989L44.0262 83.3754C45.6163 84.284 47.6607 84.284 49.478 83.3754L61.9718 76.1062L70.6038 71.1087L83.0976 63.8397C84.6877 62.931 86.7322 62.931 88.5494 63.8397L98.3173 69.5187C99.9074 70.4273 101.043 72.2445 101.043 74.289V85.6469C101.043 87.4642 100.134 89.2815 98.3173 90.4173L88.7765 96.0963C87.1864 97.0049 85.142 97.0049 83.3247 96.0963L73.5569 90.4173C71.9668 89.5086 70.831 87.6913 70.831 85.6469V78.3779L62.1989 83.3754V90.8716C62.1989 92.6888 63.1076 94.5061 64.9249 95.6419L83.3247 106.318C84.9149 107.227 86.9592 107.227 88.7765 106.318L107.176 95.6419C108.767 94.7333 109.902 92.9161 109.902 90.8716V69.2915C109.902 67.4742 108.994 65.657 107.176 64.5211L88.7765 53.8447C87.1864 52.9361 85.142 52.9361 83.3247 53.8447V53.8447Z",
    fill: "#8247E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/Matic.2cbb1e30c943b3da7c92369df48571f9.svg";
export { ForwardRef as ReactComponent };